import actionTypes from '../constants/action-types';
import actionHistoryTypes from '../../history/constants/action-types';

const hoveredElement = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_HOVERED_ELEMENT: {
      return action.payload.elementId;
    }

    case actionHistoryTypes.UNDO:
    case actionHistoryTypes.REDO:
    case actionTypes.CONNECT_MAPPED_HTML:
    case actionTypes.REPLACE_ELEMENT:
    case actionTypes.INSERT_BLOCK:
    case actionTypes.INSERT_ELEMENT:
    case actionTypes.DUPLICATE_ELEMENT:
    case actionTypes.DELETE_ELEMENT: {
      return null;
    }

    default:
      return state;
  }
};

export default hoveredElement;
